import { render, staticRenderFns } from "./v-date-month.vue?vue&type=template&id=622d490c&scoped=true&"
import script from "./v-date-month.vue?vue&type=script&lang=js&"
export * from "./v-date-month.vue?vue&type=script&lang=js&"
import style0 from "./v-date-month.vue?vue&type=style&index=0&id=622d490c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622d490c",
  null
  
)

export default component.exports